var _class, _temp2;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Dialog, DialogActions, Slide, Typography } from '@material-ui/core';
var Transition = React.forwardRef(function (props, ref) {
  return React.createElement(Slide, _extends({
    ref: ref,
    direction: 'up'
  }, props));
});
var Modal = (_temp2 = _class = function (_Component) {
  _inherits(Modal, _Component);

  function Modal() {
    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      open: false
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  /**
   * Retourne le nouveau state en fonction des nextProps
   * @param  {[type]} nextProps [description]
   * @param  {[type]} prevState [description]
   * @return {[type]}           [description]
   */


  Modal.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
    var newState = _extends({}, prevState);

    if (nextProps.openModal !== prevState.open) {
      newState = _extends({}, newState, {
        open: nextProps.openModal
      });
    }

    return newState;
  };
  /**
   * Pour valider le formulaire avec Enter
   * @param  {[type]} e [description]
   * @return {[type]}   [description]
   */


  Modal.prototype.onKeyPress = function onKeyPress(e) {
    if (e.which === 13 || e.keyCode === 13 || e.key === 'Enter') {
      // Différents modes de détection pour prendre en charge l'ensemble des navigateurs
      if (e.target.classList.contains('no-enter') || this.props.disabledEnter) {
        return;
      }

      this.props.onSubmitHandler();
    }
  };

  Modal.prototype.render = function render() {
    var _props = this.props,
        actionCancel = _props.actionCancel,
        actionMessage = _props.actionMessage,
        actionOk = _props.actionOk,
        error = _props.error,
        onCloseHandler = _props.onCloseHandler,
        onSubmitHandler = _props.onSubmitHandler,
        errorColor = _props.errorColor;
    var open = this.state.open;
    var message = null;

    if (actionMessage) {
      var messageStyle = {
        marginRight: 'auto',
        paddingLeft: '1em'
      };

      if (error) {
        messageStyle = _extends({
          color: errorColor ? errorColor : 'red'
        }, messageStyle);
      }

      message = React.createElement(Typography, {
        style: messageStyle,
        variant: 'body2'
      }, actionMessage);
    }

    var okButton = null;

    if (actionOk !== 'NONE') {
      okButton = React.createElement(Button, {
        onClick: onSubmitHandler,
        color: 'primary',
        className: 'no-enter'
      }, actionOk);
    }

    return React.createElement(Dialog, {
      onKeyPress: this.onKeyPress.bind(this),
      open: !!open ? open : false,
      TransitionComponent: Transition,
      keepMounted: true,
      onClose: onCloseHandler,
      'aria-labelledby': 'alert-dialog-slide-title',
      'aria-describedby': 'alert-dialog-slide-description',
      fullWidth: this.props.fullWidth,
      maxWidth: this.props.maxWidth,
      fullScreen: this.props.fullScreen
    }, this.props.children, React.createElement(DialogActions, null, message, React.createElement(Button, {
      onClick: onCloseHandler,
      className: 'no-enter'
    }, actionCancel), okButton));
  };

  return Modal;
}(Component), _class.defaultProps = {
  actionCancel: 'Annuler',
  actionMessage: null,
  actionOk: 'Valider'
}, _temp2);
Modal.propTypes = process.env.NODE_ENV !== "production" ? {
  actionCancel: PropTypes.string,
  actionMessage: PropTypes.string,
  actionOk: PropTypes.string,
  error: PropTypes.bool,
  openModal: PropTypes.bool,
  onCloseHandler: PropTypes.func.isRequired,
  onSubmitHandler: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]).isRequired,
  fullWidth: PropTypes.bool,
  maxWidth: PropTypes.string,
  disabledEnter: PropTypes.bool,
  errorColor: PropTypes.string,
  fullScreen: PropTypes.bool
} : {};
export default Modal;